var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Revised Date","prepend-icon":"mdi-magnify","dense":"","outlined":"","clearable":"","background-color":"white"},on:{"change":function($event){return _vm.$emit('input', _vm.filter)}},model:{value:(_vm.revisedDateTerm),callback:function ($$v) {_vm.revisedDateTerm=$$v},expression:"revisedDateTerm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }